export default __webpack_public_path__ + "static/GESSTwoDWTC-Light-31aa6584aae609f8883f95c6dd6917fe.woff";